module.exports = __webpack_public_path__ + "static/media/salt.c4876219.jpg";